import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';

import { mediaquery } from 'shared/styles/styleFunctions';
import theme from 'shared/styles/themes';

export default css({
  '&.brief-header': {
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    [mediaquery.md]: {
      height: '100%',
      flexWrap: 'wrap',
      margin: '0.15rem 0',
    },
  },
  [mediaquery.md]: {
    order: 'unset',
  },
  '.brief-header': {
    '&__name': {
      flex: 1,
      paddingRight: theme.space[5],
      margin: 0,
    },
    '&__name--clickable a': {
      color: COLORS.PRIMARY500,
    },
    '&__name--clickable a:hover': {
      textDecoration: 'underline',
    },
  },
  '.brief-header-creator-actions': {
    height: '42px',
  },
});
